<template>
  <el-dialog
    :visible="true"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    :title="$t('Audiences_Segment_DialogMembersExport_Title')"
    :before-close="onClose"
  >
    <div class="audience-box">
      <div
        class="audience-box-container"
        style="margin-right: 20px"
        :style="audienceType === 'profile' ? 'border-color:transparent' : ''"
      >
        <div
          class="audience-box-item"
          :class="{ 'active-class': audienceType === 'profile' }"
          @click="audienceType = 'profile'"
        >
          <i class="el-icon-user"></i>
          <h3>{{ $t('Audiences_Type_Users') }}</h3>
          <p class="audience-box-item-description">
            {{ $t('Audiences_Type_Users_Description') }}
          </p>
        </div>
      </div>
      <div
        class="audience-box-container"
        :style="audienceType === 'device' ? 'border-color:transparent' : ''"
      >
        <div
          class="audience-box-item"
          :class="{ 'active-class': audienceType === 'device' }"
          @click="audienceType = 'device'"
        >
          <i class="el-icon-mobile-phone"></i>
          <h3>{{ $t('Audiences_Type_Devices') }}</h3>
          <p class="audience-box-item-description">
            {{ $t('Audiences_Type_Devices_Description') }}
          </p>
        </div>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-dropdown
        trigger="click"
        @command="handleActions"
        v-if="audienceType === 'profile'"
      >
        <el-button type="primary" plain :disabled="audienceType === null">
          {{ $t('Audiences_Segment_DialogMembersExport_Dropdown_Next') }}
          <i class="el-icon-arrow-up el-icon--right" />
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="addAttributesToExport">
            {{ $t('Audiences_Segment_Export_Action_AddAttributes') }}
          </el-dropdown-item>
          <el-dropdown-item command="runExport">
            {{ $t('Audiences_Segment_Export_Action_RunExport') }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-button
        @click="handleActions('runExport')"
        type="primary"
        plain
        :disabled="audienceType === null"
        v-else
      >
        {{ $t('Audiences_Segment_Export_Action_RunExport') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { EventBus } from '@/core/EventBus'
export default {
  name: 'MembersExportDialog',
  data() {
    return {
      audienceType: null
    }
  },
  methods: {
    onClose() {
      EventBus.$emit('export-members-hide')
    },
    handleActions(action) {
      switch (action) {
        case 'addAttributesToExport':
          EventBus.$emit('export-members-add-attributes-show', {
            exportType: this.audienceType,
            action: 'add-attributes'
          })
          break
        case 'runExport':
          EventBus.$emit('export-members-run-show', {
            exportType: this.audienceType,
            action: 'run-export'
          })
          break
      }
    }
  }
}
</script>

<style scoped>
.active-class {
  background-color: #f2f5f9;
  border: 3px solid #1d87c8;
}
.audience-box {
  display: flex;
  justify-content: center;
}
.audience-box-container {
  border: 1px solid #a7acba;
  border-radius: 4px;
  transition: all 0.5s;
}
.audience-box-container:hover {
  box-shadow: rgba(67, 90, 111, 0.3) 0px 0px 1px,
    rgba(67, 90, 111, 0.47) 0px 8px 10px -4px;
  transform: translateY(-2px);
  cursor: pointer;
}
.audience-box-item {
  width: 300px;
  height: 220px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.audience-box-item i {
  color: #1d87c8;
  font-size: 100px;
  line-height: 100px;
}

.dialog-footer {
  display: flex;
  justify-content: center;
}

.audience-box-item-description {
  padding: 10px;
  word-break: break-word;
}
</style>



// WEBPACK FOOTER //
// src/modules/audiences/components/MembersExportDialog.vue